// src/components/Dashboard/ClubCoordinator/ClubCoordinator.js
import React, { useState, useEffect } from 'react';
import { collection, getDocs, query, where } from 'firebase/firestore';
import { db } from '../../../services/firebase'; // Fixed path
import MemberApplications from './MemberApplications'; // Fixed path
import PartnerApplications from './PartnerApplications'; // Fixed path
import ClubCoordinatorHome from './ClubCoordinatorHome'; // Fixed path
import './ClubCoordinator.css';

const ClubCoordinator = () => {
  const [currentView, setCurrentView] = useState('home');
  const [memberApplications, setMemberApplications] = useState([]);
  const [partnerApplications, setPartnerApplications] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchApprovedApplications = async () => {
      try {
        const memberQuery = query(
          collection(db, 'memberApplications'),
          where('status', '==', 'approved')
        );
        const partnerQuery = query(
          collection(db, 'partnerApplications'),
          where('status', '==', 'approved')
        );

        const [memberSnapshot, partnerSnapshot] = await Promise.all([
          getDocs(memberQuery),
          getDocs(partnerQuery)
        ]);

        const members = memberSnapshot.docs.map(doc => ({
          id: doc.id,
          ...doc.data(),
          type: 'member',
          name: doc.data().fullNames || 'N/A'
        }));

        const partners = partnerSnapshot.docs.map(doc => ({
          id: doc.id,
          ...doc.data(),
          type: 'partner',
          name: doc.data().entityRegisteredName || doc.data().tradingName || 'N/A'
        }));

        setMemberApplications(members);
        setPartnerApplications(partners);
        setLoading(false);
      } catch (error) {
        console.error('Error fetching approved applications:', error);
        setLoading(false);
      }
    };

    fetchApprovedApplications();
  }, []);

  const renderContent = () => {
    switch (currentView) {
      case 'home':
        return <ClubCoordinatorHome />;
      case 'member':
        return (
          <MemberApplications
            applications={memberApplications}
            loading={loading}
          />
        );
      case 'partner':
        return (
          <PartnerApplications
            applications={partnerApplications}
            loading={loading}
          />
        );
      case 'all':
        return (
          <div className="combined-view">
            <h3>All Approved Applications</h3>
            <MemberApplications
              applications={memberApplications}
              loading={loading}
              showTitle={false}
            />
            <PartnerApplications
              applications={partnerApplications}
              loading={loading}
              showTitle={false}
            />
          </div>
        );
      default:
        return <ClubCoordinatorHome />;
    }
  };

  return (
    <div className="dashboard">
      <h2>Club Coordinator Dashboard</h2>
      
      <div className="coordinator-tabs">
        <button 
          className={currentView === 'home' ? 'active' : ''}
          onClick={() => setCurrentView('home')}
        >
          Home
        </button>
        <button 
          className={currentView === 'member' ? 'active' : ''}
          onClick={() => setCurrentView('member')}
        >
          Member Applications ({memberApplications.length})
        </button>
        <button 
          className={currentView === 'partner' ? 'active' : ''}
          onClick={() => setCurrentView('partner')}
        >
          Partner Applications ({partnerApplications.length})
        </button>
        <button 
          className={currentView === 'all' ? 'active' : ''}
          onClick={() => setCurrentView('all')}
        >
          All Applications ({memberApplications.length + partnerApplications.length})
        </button>
      </div>

      <div className="coordinator-content">
        {renderContent()}
      </div>
    </div>
  );
};

export default ClubCoordinator;